import { useCallback, useContext, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import SubmitButton from "../../components/SubmitButton";
import { refusalSentence } from "../../lib/api";
import { NotificationContext } from "../../Notifications";
import { useArchiveHousehold } from "./lib";

const HouseholdArchiveDialog = ({
  showModal,
  setShowModal,
  archiveHouseholdId,
  archiveHouseholdName,
}: {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  archiveHouseholdId: number;
  archiveHouseholdName: string;
}) => {
  const handleModalClose = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  const [archiveEnabled, setArchiveEnabled] = useState(false);

  const checkArchiveEnabled = (value: string) => {
    setArchiveEnabled(value === archiveHouseholdName);
  };

  const { mutateAsync: archiveHousehold } =
    useArchiveHousehold(archiveHouseholdId);

  const notificationContext = useContext(NotificationContext);

  const handleArchiveHousehold = useCallback(async () => {
    try {
      await archiveHousehold();

      setShowModal(false);
      notificationContext.pushNotification({
        id: `household-${archiveHouseholdId}`,
        header: "Household Archived",
        body: `${archiveHouseholdName} archived`,
        variant: "success",
      });
    } catch (ex) {
      console.error("Failed to archive household", ex);
      notificationContext.pushNotification({
        id: `household-${archiveHouseholdId}`,
        header: "Failed to Archive Household",
        // The api's sentence for a refusal, the fixed text for any other failure.
        body: refusalSentence(ex) ?? `${archiveHouseholdName} was not archived`,
        variant: "danger",
      });
    }
  }, [
    archiveHousehold,
    archiveHouseholdId,
    archiveHouseholdName,
    notificationContext,
    setShowModal,
  ]);

  return (
    <Modal
      show={showModal}
      onHide={handleModalClose}
      aria-labelledby="contained-modal-title-vcenter"
      scrollable={true}
      centered
    >
      <Modal.Header>
        <Modal.Title>Archive Household</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>
          Are you sure you would like to archive {archiveHouseholdName}?
        </Form.Label>
        <Form.Control
          style={{ width: "90%" }}
          type="text"
          placeholder="Enter household name"
          onChange={(e) => checkArchiveEnabled(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
          Discard
        </Button>
        <SubmitButton
          variant="danger"
          label="Confirm"
          disabled={!archiveEnabled}
          onClick={handleArchiveHousehold}
        />
      </Modal.Footer>
    </Modal>
  );
};
export default HouseholdArchiveDialog;
